import { render, staticRenderFns } from "./Funil.vue?vue&type=template&id=0bfc36fa&scoped=true"
import script from "./Funil.vue?vue&type=script&lang=js"
export * from "./Funil.vue?vue&type=script&lang=js"
import style0 from "./Funil.vue?vue&type=style&index=0&id=0bfc36fa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bfc36fa",
  null
  
)

export default component.exports